import InvoiceDetailsComp from "./InvoiceDetailsComp";
import { useState } from "react";
import { Button } from "reactstrap";
import { Col, Row } from "reactstrap";
import "./InvoiceDetailsComp.css";
import { useParams } from "react-router-dom";
import { addInvoice, getInvoicePreview } from "../../../../api/invoices";
import { useGetInstence } from "../../../../hooks/useGetInstence";
import { useHistory } from "react-router-dom";
import { useResponse } from "../../../../hooks/useResponse";
import ResultHandler from "../../../../components/ResultHandler";

const InvoiceDetailsPreview = () => {
  const navigate = useHistory();
  const { contractId } = useParams();
  const [invoice, setInvoice] = useState(null);

  const { instenceLoading } = useGetInstence(
    getInvoicePreview,
    contractId,
    (response) => {
      setInvoice({
        ...response.data.invoice,
      });
    }
  );

  // Generate
  const { setData, loading, error, success } = useResponse(addInvoice, () => {
    navigate.push('/invoices')
  })
  
  const handleGenerateClick = () => {
    const company = invoice.contract?.company.id
    const contracts = [invoice.contract?.id]
    const data = {company, contracts}
    setData({ data, type: "add" })
  }

  return (
    <div className="page-content invoice-details">
      <div className="container">
        {!instenceLoading && invoice && (
          <>
            <InvoiceDetailsComp invoice={invoice} />

            <Row className="g-3">
                <ResultHandler
                  error={error}
                  success={success}
                  successMsg={"Created Successfully!"}
                />

              <Col className="print mb-5" md={12}>
                <Button size="lg" color="primary" onClick={handleGenerateClick} disabled={loading}>
                  {loading ? 'Loading...' : 'Generate'}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default InvoiceDetailsPreview;
